import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import AppBar from "material-ui/AppBar";
import IconButton from "material-ui/IconButton";
import Toolbar from "material-ui/Toolbar";
import Hidden from "material-ui/Hidden";
import CurrentUserContainer from "./CurrentUserContainer";
import Typography from "material-ui/Typography";
import AppBarSearchContainer from "./AppBarSearchContainer";
import MenuIcon from "material-ui-icons/Menu";
import Drawer from "material-ui/Drawer";

const drawerWidth = 260;

const styles = theme => ({
  root: {
    position: "absolute",
    bottom: 1,
    right: 0,
    left: 1,
    top: 0,
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  },
  grow: {
    flex: "1 1 auto"
  },
  content: {
    display: "flex",
    flexDirection: "row",
    height: "100%",
    overflow: "hidden"
  },
  left: {
    flexGrow: 1,
    overflow: "auto"
  },
  sidebar: {
    position: "relative",
    height: "100%",
    zIndex: 0,
    width: drawerWidth,
    flexShrink: 0,
    borderLeftColor: theme.palette.common.faintBlack,
    borderLeftStyle: "solid",
    borderLeftWidth: 1
  },
  button: {
    position: "absolute",
    bottom: 20,
    right: 36
  }
});

const MainFrame = props => {
  const {
    appBarHeight,
    body,
    classes,
    fab,
    indent,
    isError,
    isInMonitoringMode,
    onOpenDrawer,
    sidebar,
    sidebarOpen,
    subBar,
    title
  } = props;

  const indentWidth = isInMonitoringMode ? 0 : indent;
  const appBarWidth = `calc(100% - ${indentWidth}px)`;

  const renderAppBar = () => {
    if (isInMonitoringMode) {
      return;
    }

    if (isError) {
      return (
        <AppBar style={{ width: appBarWidth }}>
          <Toolbar />
        </AppBar>
      );
    }

    return (
      <AppBar style={{ width: appBarWidth }}>
        <Toolbar>
          <Hidden only={["lg", "md"]}>
            <IconButton color="contrast" onClick={onOpenDrawer}>
              <MenuIcon />
            </IconButton>
          </Hidden>
          <Typography type="title" color="inherit" noWrap>
            {title}
          </Typography>
          <div className={classes.grow} />
          <AppBarSearchContainer />
          <CurrentUserContainer />
        </Toolbar>
        {subBar}
      </AppBar>
    );
  };

  const renderSidebarDrawer = () => {
    if (sidebarOpen && sidebar) {
      return (
        <Drawer
          anchor="right"
          type="persistent"
          open={sidebarOpen}
          classes={{
            paper: classes.sidebar
          }}
        >
          {sidebar}
        </Drawer>
      );
    }
  };

  return (
    <div className={classes.root}>
      {renderAppBar()}
      <div
        className={classes.content}
        style={{
          marginLeft: indentWidth,
          marginTop: indentWidth ? appBarHeight : 0
        }}
      >
        <div className={classes.left}>{body}</div>

        {renderSidebarDrawer()}
      </div>
      {fab}
    </div>
  );
};

MainFrame.propTypes = {
  indent: PropTypes.number.isRequired,
  appBarHeight: PropTypes.number.isRequired,
  body: PropTypes.element.isRequired,
  onOpenDrawer: PropTypes.func.isRequired,
  subBar: PropTypes.element,
  fab: PropTypes.element,
  sidebar: PropTypes.element,
  title: PropTypes.string,
  isError: PropTypes.bool,
  sidebarOpen: PropTypes.bool
};

MainFrame.defaultProps = {
  isError: false,
  appBarHeight: 64,
  sidebarOpen: false
};

export { MainFrame };

export default withStyles(styles, { name: "MainFrame" })(MainFrame);



// WEBPACK FOOTER //
// ./src/MainFrame.js